import apiHeader from '@/helpers/apiHeader';

const blockUnblockFormService = {
    save(id, params) {
        return apiHeader.post(`request-pool/block-unblock/save/${id}`, params);
    },
};

export default blockUnblockFormService;
